/**
 * Jambuveda cart-drawer cross-sell upsell.
 *
 * Uses event delegation on document rather than binding directly to the
 * button, because Dawn's cart-drawer replaces #CartDrawer's innerHTML on
 * every add/remove/quantity change — a directly-bound listener would be
 * destroyed along with the old button on the very next render.
 */
(function () {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-jv-upsell-variant-id]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled')) return;

    const variantId = btn.dataset.jvUpsellVariantId;
    const prevText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.setAttribute('disabled', '');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await sectionsRes.json();
        // renderContents() also calls open() internally, but open() returns
        // early if the drawer is already active — safe to call while open,
        // it just refreshes the content in place without re-animating.
        drawer.renderContents({ id: Number(variantId), sections });
      }
    } catch (err) {
      console.error('Jambuveda cart upsell error', err);
      btn.textContent = 'Try again';
      btn.removeAttribute('disabled');
      setTimeout(() => { btn.textContent = prevText; }, 1500);
    }
  });
})();
